import classNames from "classnames";
import React from "react";

import styles from "../FormField.module.scss";

export interface IInnFormField {
  id?: string;
  error?: string;
  name?: string;
  readOnly?: boolean;
  registerField?: any;
  isFocused?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  checksPresenceName?: (
    e: React.ChangeEvent<HTMLInputElement> | React.FocusEvent<HTMLElement>,
    name: string,
  ) => void;
}

export const InnFormField: React.FC<IInnFormField> = ({
  id,
  error,
  name,
  readOnly = false,
  registerField,
  isFocused,
  onFocus,
  onBlur,
  checksPresenceName,
  autoComplete,
}) => {
  const PATTERN = /\D/g;
  const formatMask = "x".repeat(10);

  const getInputNumbersValue = (value: string) => {
    return value.replace(PATTERN, "");
  };

  const clearValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target;
    input.value = getInputNumbersValue(input.value);
  };

  const handleInnInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (checksPresenceName) {
      checksPresenceName(e, name);
    }
    const input = e.target;

    let val = "";
    const x = input.value
      .replace(PATTERN, "")
      .match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})/);
    if (x[2] === "" && x[1] !== "") {
      val = x[1];
    } else {
      val = !x[3] ? x[1] + x[2] : x[1] + x[2] + x[3] + x[4];
    }

    input.value = val?.length ? val + formatMask.slice(val.length, 10) : val;
    input.selectionStart = val.length;
    input.selectionEnd = val.length;
  };

  const handleInnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    if (
      e.key === "Backspace" &&
      getInputNumbersValue(input.value).length === 1
    ) {
      input.value = "";
    }
    return input;
  };

  const handleInnPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData ?? window["clipboardData"];
    const input = e.target as HTMLInputElement;
    const inputNumbersValue = getInputNumbersValue(input.value);

    if (pasted) {
      const pastedText = pasted.getData("Text");
      if (PATTERN.test(pastedText)) {
        input.value = inputNumbersValue;
      }
    }
  };

  return (
    <input
      {...registerField}
      id={id}
      className={classNames(styles.input, {
        [styles.error]: error,
        [styles.active]: isFocused,
      })}
      name={name}
      type="text"
      minLength={10}
      readOnly={readOnly}
      onInput={handleInnInput}
      onKeyDown={handleInnKeyDown}
      onPaste={handleInnPaste}
      onFocus={(e) => {
        onFocus(e);
        clearValue(e);
      }}
      onBlur={(e) => {
        onBlur(e);
        clearValue(e);
      }}
      autoComplete={autoComplete}
    />
  );
};
